"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.email.contacts': 'Contactos',
    'whatsapp.email.noContacts': 'No se encontraron contactos de correo electrónico.',
    'whatsapp.email.loadFailed': 'Error al cargar contactos de correo electrónico.',
    'whatsapp.email.stats.contacts': 'Contactos',
    'whatsapp.email.stats.total': 'Total',
    'whatsapp.email.trackLogs': 'Registros de seguimiento',
    'whatsapp.email.noLogs': 'Aún no hay registros de seguimiento.',
};
